import 'jquery-toast-plugin/dist/jquery.toast.min'
import 'jquery-toast-plugin/dist/jquery.toast.min.css'
import Component from "vue-class-component";
import $ from "jquery";
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import translations from '../i18n/messages'

@Component
export class ComponentBaseMixin extends Vue {

    showInfo(message: string) {
        const translator = this.getTranslator();
        const title = <string>(translator).t('informacija');
        const msg = <string>translator.t(message);

        $.toast({
            heading: title,
            text: msg,
            position: "top-right",
            loaderBg: "#3b98b5",
            icon: "info",
            hideAfter: 3e3,
            stack: 1
        });
    }

    showError(message: string) {
        const translator = this.getTranslator();
        const title = <string>(translator).t('greska');
        const msg = <string>translator.t(message);

        $.toast({
            heading: title,
            text: msg,
            position: "top-right",
            loaderBg: "#bf441d",
            icon: "error",
            hideAfter: 3e3,
            stack: 5
        });
    }

    private getTranslator() {
        return this.$i18n || new VueI18n({
            messages: translations
        });
    }

    async confirmationNeeded(message: string) {
        const {value} = await this.$swal({
            title: <string>this.$i18n.t('potvrda'),
            text: <string>this.$i18n.t(message),
            cancelButtonText: <string>this.$i18n.t('ne'),
            confirmButtonText: <string>this.$i18n.t('da'),
            showCancelButton: true
        });
        return value || false;
    }
}
